<template>
    <div>
        <div style="margin-top: 50px; text-align: center">
            <slot></slot>
        </div>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title class="bigger-title">Confirmation</v-card-title>
                <v-card-text class="bigger-text">
                    <v-icon class="text-success">mdi-check-circle</v-icon> Form submitted successfully!</v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="handleConfirm"> OK </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <b-alert
            v-if="approved"
            class="custom-alert"
            type="success"
            show
            message="Form has been successfully approved!"
        ></b-alert>
        <b-alert
            v-if="rejected"
            class="custom-alert"
            type="danger"
            show
            message="Form has been successfully rejected!"
        ></b-alert>
        <b-alert v-if="error" class="custom-ss-alert" type="danger" show :message="errorMessage"></b-alert>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialog: false,
            approved: false,
            rejected: false,
            error: false,
            errorMessage: '',
        };
    },
    mounted() {
        this.$root.$on('form-approved', () => {
            this.approved = true;
        });
        this.$root.$on('form-rejected', () => {
            this.rejected = true;
        });
        this.$root.$on('show-confirmation-dialog', () => {
            this.dialog = true;
        });
        this.$root.$on('show-error-dialog', (message) => {
            this.error = true;
            this.errorMessage = message;
        });
    },
    beforeDestroy() {
        this.$root.$off('show-confirmation-dialog');
        this.$root.$off('form-approved');
        this.$root.$off('form-rejected');
        this.$root.$off('show-error-dialog');
    },
    methods: {
        handleConfirm() {
            this.dialog = false;
            window.location.href = route('users.index');
        },
    },
};
</script>
<style scoped>
.bigger-text {
    font-size: 1.25rem;
}
.bigger-title {
    font-size: 1.6rem !important;
}
.custom-alert {
    transform: translate(0%, 0%);
    position: fixed;
    display: block;
    top: 0;
    left: 0;
    padding-top: 5px;
}
</style>
